import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisplayValidationErrorsDirective, IRoadConditionsForm } from '@curbnturf/form-helpers';

@Component({
  selector: 'curbnturf-road-conditions',
  templateUrl: './road-conditions.component.html',
  styleUrls: ['./road-conditions.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, ReactiveFormsModule, NgClass, DisplayValidationErrorsDirective],
})
export class RoadConditionsComponent {
  @Input() roadCondition: FormGroup<IRoadConditionsForm>;

  selected(condition: string): boolean {
    if (!this.roadCondition) {
      return true;
    }

    const conditionInput = this.roadCondition.get(condition);
    return conditionInput ? conditionInput.value : false;
  }
}
